export default [
  {
    path: '/ypkp',
    component: () => import('./views/index')
  },
  {
    path: '/ypkp/search',
    component:()=>import('./views/search')
  }
]



// WEBPACK FOOTER //
// ./src/page/ypkp/router.js